export default {
  'download.title': 'Download the app and trade whenever you want',
  'download.tip': 'Biconomy mobile app is fully compatible with iOS and Android operation systems.',
  'download.item_title_1': 'Top Exchange',
  'download.item_desc_1': 'We are a leading exchange in terms of real daily trading volume.',
  'download.item_title_2': 'Optimized User Experience',
  'download.item_desc_2': 'We have created a streamlined buying and selling experience with low rates',
  'download.item_title_3': 'Secure Trading Platform',
  'download.item_desc_3': 'We have a multi-tier and multi-cluster system architecture..',
  'download.item_title_4': 'Top Coins Available',
  'download.item_desc_4': 'We list only top coins and carefully evaluated projects.',
};
